import script from "./PixKeyReadOnlyTextField.vue?vue&type=script&setup=true&lang=js"
export * from "./PixKeyReadOnlyTextField.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__